var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.698 14.4587L15.4547 13.8463L16.6705 15.1188C17.1177 15.5869 17.8427 15.5869 18.2899 15.1188L21.7608 11.4858C22.0799 11.1518 22.0799 10.6103 21.7608 10.2764L15.9394 4.18285C13.539 1.67028 9.77774 1.28111 6.95386 3.25313L9.78759 6.21922V8.76192L9.38412 9.18361C8.93636 9.6516 8.93609 10.411 9.38352 10.8793L12.5264 14.169C12.8331 14.4899 13.2866 14.6021 13.698 14.4587Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.67078 20.8063C1.71272 19.8034 1.79134 18.1539 2.84001 17.2559L9.78824 11.3055L12.2173 13.8481L6.53237 21.1208C5.67435 22.2184 4.09843 22.3007 3.14035 21.2978L2.67078 20.8063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.267e1356c2459ce00fb0d192a970ee0a.svg";
export { ForwardRef as ReactComponent };